import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { withVar } from "themes/helpers";

export const CannedResponseText = styled.div`
  flex: 0 1 auto;
  width: 100%;
  max-width: 460px;
  white-space: pre-line;
  word-break: break-word;
  font-size: 15px;
  line-height: 22px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};

  img {
    margin-top: ${withVar(SpacingToken.Spacing2)};
    max-width: 100%;
    height: auto;
    image-orientation: from-image;
  }

  img.hd-image {
    margin-top: ${withVar(SpacingToken.Spacing2)};
    max-width: 460px;
    height: auto;
  }

  @media (max-width: ${ResponsiveBreakpoint.Mobile}px) {
    img.hd-image {
      max-width: 230px;
      height: auto;
    }
  }

  p {
    font-size: 15px;
    line-height: 22px;
    margin: 0;
    color: ${withVar(DesignToken.ContentBasicPrimary)};
  }

  ol {
    list-style: decimal;
    margin: 10px 20px;
  }

  ul {
    list-style: disc;
    margin: 10px 20px;
  }
`;
